import React, { useState, useEffect } from "react";
import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  IconButton,
  CircularProgress,
  Box,
  colors,
} from "@mui/material";
import { IoMdRadioButtonOn } from "react-icons/io";
import { FaLocationDot } from "react-icons/fa6";
import { IoMdTime } from "react-icons/io";
import { FaBagShopping } from "react-icons/fa6";
import { FaBox } from "react-icons/fa";
import { FaBezierCurve } from "react-icons/fa";
import { FaMapLocationDot } from "react-icons/fa6";
import { GoSearch } from "react-icons/go";
import { ClosedDelivery } from "../closedDeliveries";
import { ReallotedDelivery } from "../reallotedDeliveries";
import { NewDelivery } from "../newDeliveries";
import { InprogressDelivery } from "./inprogressDeliveries";
import { CompletedDelivery } from "./trackDelivery";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { axiosInstance } from "../../../axiosInstance";
import { toast } from "react-toastify";

const columns = [
  // { id: "delivery_id", label: "DELIVERY ID", minWidth: 170, align: "center" },
  { id: "order_id", label: "ORDER ID", minWidth: 170, align: "center" },
  { id: "ryder_id", label: "RYDER ID", minWidth: 170, align: "center" },
  {
    id: "delivery_type",
    label: "DELIVERY TYPE",
    minWidth: 170,
    align: "center",
  },
  {
    id: "pick_up_location",
    label: "PICKUPLOCATION",
    minWidth: 200,
    align: "center",
  },
  {
    id: "drop_location",
    label: "DROP LOCATION",
    minWidth: 170,
    align: "center",
  },
  {
    id: "created_at",
    label: "DELIVERY SLOT TIME",
    minWidth: 170,
    align: "center",
  },
  // { id: "typeofpack", label: "TYPE OF PACK", minWidth: 130, align: "center" },
  // { id: "no_of_pack", label: "NO OF PACKS", minWidth: 130, align: "center" },
  {
    id: "vehicle_type",
    label: "VECHICLE TYPE",
    minWidth: 130,
    align: "center",
  },
  { id: "action", label: "ACTION", minWidth: 130, align: "center" },
];

function createData(
  ryder_id,
  pick_up_location,
  delivery_type,
  drop_location,
  created_at,
  typeofpack,
  no_of_pack
) {
  return {
    ryder_id,
    pick_up_location,
    delivery_type,
    drop_location,
    created_at,
    typeofpack,
    no_of_pack,
  };
}

const rows = [
  createData(
    "#AB1234",
    "#GMKDP123",
    "Shiva Sai Agencies",
    "Vasavi Traders",
    "10:30-11:00",
    "Bag",
    "04"
  ),
  createData(
    "#AB1234",
    "#GMKDP123",
    "Shiva Sai Agencies",
    "Vasavi Traders",
    "10:30-11:00",
    "Box",
    "04"
  ),
];

export function OutforDelivery() {
  const [inprogressDeliveryList, setInprogressDeliveryList] = useState([]);
  const [totalCount, setTotalCount] = useState(0);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const [searchQuery, setSearchQuery] = useState("");

  const navigate = useNavigate();

  // const [page, setPage] = useState(0);
  // const [rowsPerPage, setRowsPerPage] = useState(20);
  // const handleChangePage = (event, newPage) => {
  //   setPage(newPage);
  // };

  // const handleChangeRowsPerPage = (event) => {
  //   setRowsPerPage(+event.target.value);
  //   setPage(0);
  // };

  // save table page size in local to save data on page change
  const [page, setPage] = useState(() => {
    const saved = localStorage.getItem("trackorder_page");
    return saved ? Number(saved) : 0;
  });

  const [rowsPerPage, setRowsPerPage] = useState(() => {
    const saved = localStorage.getItem("trackorder_rowsPerPage");
    return saved ? Number(saved) : 20;
  });

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
    localStorage.setItem("trackorder_page", newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    const value = Number(event.target.value);

    setRowsPerPage(value);
    setPage(0);

    localStorage.setItem("trackorder_rowsPerPage", value);
    localStorage.setItem("trackorder_page", 0);
  };

  const fetchInProgressDeliverys = async (
    pageNumber = 0,
    pageSize = rowsPerPage
  ) => {
    setLoading(true);
    setError("");
    try {
      const res = await axiosInstance.get(
        // "/admin/deliveries/?pickup_status=picked"
        // "/admin/deliveries/?pickup_status="
        `/admin/track-orders?page=${pageNumber + 1}&page_size=${pageSize}`
      );
      console.log("✅ In progress Deliverys list response:", res.data);
      if (res.data.results?.data) {
        setInprogressDeliveryList(res.data.results.data || []);
        setTotalCount(res.data.count || 0);
      } else {
        setError("Failed to fetch In progress Deliverys  data.");
      }
    } catch (err) {
      console.error("❌ Error fetching In progress Deliverys  data:", err);
      setError("Something went wrong. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchInProgressDeliverys(page, rowsPerPage);
  }, [page, rowsPerPage]);

  const filteredData = inprogressDeliveryList.filter((row) => {
    const query = searchQuery.toLowerCase();

    const orderIdStr = String(row.order_id ?? "").toLowerCase();
    const ryderIdStr = String(row.ryder_id ?? "").toLowerCase();
    const deliveryIdStr = String(row.delivery_id ?? "").toLowerCase();
    const pickupStr = String(row.pick_up_location ?? "").toLowerCase();
    const dropStr = String(row.drop_location ?? "").toLowerCase();

    return (
      orderIdStr.includes(query) ||
      ryderIdStr.includes(query) ||
      deliveryIdStr.includes(query) ||
      pickupStr.includes(query) ||
      dropStr.includes(query)
    );
  });

  function formatDateTime(dateString) {
    if (!dateString) return "--";

    try {
      // Split date and time
      const [datePart, timePart, meridian] = dateString.split(" ");

      // Extract year, month, day
      const [year, month, day] = datePart.split("-");

      // Return formatted as DD/MM/YYYY HH:MM AM/PM
      return `${day}/${month}/${year} ${timePart} ${meridian}`;
    } catch (error) {
      return "--";
    }
  }

  return (
    <div>
      <div className="delivery-top-container">
        <div className="admin-listText">Out for Delivery </div>
        {/* <div>
          <select
            className="listAdmin-showRecords"
            value={rowsPerPage}
            onChange={handleChangeRowsPerPage}
          >
            <option value={20}>Show No of Records</option>
            <option value={50}>50</option>
            <option value={100}>100</option>
            <option value={500}>500</option>
            <option value={1000}>1000</option>
            <option value={2000}>2000</option>
            <option value={5000}>5000</option>
          </select>
        </div> */}
        <div className="search-container">
          <div className="nav-search ">
            <span className="search-icons">
              <GoSearch />
            </span>
            <input
              type="text"
              placeholder="Search"
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
            />
          </div>
        </div>
      </div>
      <div className="btnContainer">
        <button
          style={{
            // backgroundColor: "#FF961F",
            backgroundColor: "#1265c5",
            color: "white",
            display: "flex",
          }}
          onClick={() => navigate("/out-for-delivery")}
        >
          <FaMapLocationDot style={{ marginRight: "8px" }} />
          Track Your Orders
        </button>
        <button
          // style={{ backgroundColor: "#34C759", color: "white" }}
          style={{ backgroundColor: "#E8E8E9" }}
          onClick={() => navigate("/delivery")}
        >
          Unassigned
        </button>
        <button
          // style={{ backgroundColor: "#FF961F", color: "white" }}
          style={{ backgroundColor: "#E8E8E9" }}
          onClick={() => navigate("/inprogress-delivery")}
        >
          {/* In Process */}
          Re-Assign
        </button>
        <button
          style={{ backgroundColor: "#E8E8E9" }}
          onClick={() => navigate("/closed-delivery")}
        >
          Delivered
        </button>
        {/* <button
          style={{ backgroundColor: "#1265C5", color: "white" }}
          onClick={() => navigate("/realloted-delivery")}
        >
          ReAlloted
        </button> */}
      </div>
      <Paper sx={{ width: "100%", overflow: "hidden" }}>
        <Box sx={{ width: "100%", overflowX: "auto" }}>
          <TableContainer
            sx={{
              maxHeight: 640,
              minWidth: 1800,
              overflowX: "auto",
            }}
            className="Table-container"
          >
            <Table stickyHeader aria-label="sticky table">
              <TableHead>
                <TableRow>
                  {columns.map((column) => (
                    <TableCell
                      key={column.id}
                      align={column.align}
                      style={{ minWidth: column.minWidth }}
                      className="table-header"
                    >
                      {column.label}
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>
              <TableBody>
                {loading ? (
                  <TableRow>
                    <TableCell colSpan={columns.length} align="center">
                      <CircularProgress />
                    </TableCell>
                  </TableRow>
                ) : filteredData.length > 0 ? (
                  filteredData
                    // .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                    .map((row, index) => (
                      <TableRow
                        key={index}
                        hover
                        className="table-row"
                        sx={{
                          backgroundColor:
                            index % 2 === 1 ? "#E7F0F9" : "white",
                        }}
                      >
                        {columns.map((column) => {
                          const value = row[column.id];
                          return (
                            <TableCell
                              key={column.id}
                              align={column.align}
                              className="tableCelldata"
                              onClick={
                                column.id === "order_id"
                                  ? () =>
                                      navigate(
                                        // `/closed-delivery-details/${row.delivery_id}`
                                        `/track-delivery-detailes/${row.orderitem_id}`
                                      )
                                  : undefined
                              }
                              sx={{
                                cursor:
                                  column.id === "order_id"
                                    ? "pointer"
                                    : "default",
                                color:
                                  column.id === "order_id" ? "#4184D1" : "",
                              }}
                            >
                              {column.id === "pick_up_location" ? (
                                <div
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                    gap: "8px",
                                  }}
                                >
                                  <IoMdRadioButtonOn
                                    style={{
                                      fontSize: "18px",
                                      color: "#34C759",
                                    }}
                                  />
                                  {value || "--"}
                                </div>
                              ) : column.id === "delivery_type" ? (
                                <span>
                                  {value
                                    ? value
                                        .replace(/_/g, " ")
                                        .replace(/\b\w/g, (char) =>
                                          char.toUpperCase()
                                        )
                                    : "--"}
                                </span>
                              ) : column.id === "drop_location" ? (
                                <div
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                    gap: "8px",
                                  }}
                                >
                                  <FaLocationDot
                                    style={{
                                      fontSize: "18px",
                                      color: "#F52D56",
                                    }}
                                  />
                                  {value || "--"}
                                </div>
                              ) : column.id === "created_at" ? (
                                <div
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                    gap: "8px",
                                  }}
                                >
                                  <IoMdTime
                                    style={{
                                      fontSize: "18px",
                                      color: "#FF961F",
                                    }}
                                  />
                                  <span
                                    style={{
                                      border: "1px solid rgb(168, 199, 231)",
                                      padding: "5px",
                                      borderRadius: "5px",
                                    }}
                                  >
                                    {formatDateTime(value) || "--"}
                                  </span>
                                </div>
                              ) : column.id === "vehicle_type" ? (
                                <div
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                    gap: "8px",
                                  }}
                                >
                                  {value === "Bag" ? (
                                    <FaBezierCurve
                                      style={{
                                        fontSize: "18px",
                                        color: "#FF961F",
                                      }}
                                    />
                                  ) : (
                                    <FaBezierCurve
                                      style={{
                                        fontSize: "18px",
                                        color: "#FF961F",
                                      }}
                                    />
                                  )}
                                  {value || "--"}
                                </div>
                              ) : column.id === "action" ? (
                                <div>
                                  <span
                                    style={{
                                      backgroundColor: "#FF961F",
                                      color: "white",
                                      padding: "5px",
                                      borderRadius: "5px",
                                      cursor: "pointer",
                                    }}
                                    onClick={() =>
                                      navigate(
                                        // `/track-delivery/${row.delivery_id}`
                                        `/track-delivery/${row.orderitem_id}`
                                      )
                                    }
                                  >
                                    Tracking
                                  </span>
                                </div>
                              ) : (
                                value || "--"
                              )}
                            </TableCell>
                          );
                        })}
                      </TableRow>
                    ))
                ) : (
                  <TableRow>
                    <TableCell colSpan={columns.length} align="center">
                      No Data Available
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </TableContainer>
        </Box>
        <TablePagination
          rowsPerPageOptions={[20, 50, 100, 500, 1000, 2000, 5000]}
          component="div"
          count={totalCount}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
      </Paper>
    </div>
  );
}
